// Client-side pass export — captures the exact on-screen card so Print, PDF
// and JPG always look identical.
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const PX_TO_MM = 25.4 / 96;

async function renderCard(element) {
    return html2canvas(element, {
        scale: 2.5,                    // ~240 DPI — crisp on mobile + print
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
    });
}

export async function downloadPassJpeg(element, filename = "visitor-pass.jpg") {
    const canvas = await renderCard(element);
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/jpeg", 0.92);
    link.download = filename;
    link.click();
}

export async function downloadPassPdf(element, filename = "visitor-pass.pdf") {
    const canvas = await renderCard(element);
    // Card-sized single page matching the element's true aspect ratio.
    const wMm = (canvas.width / 2.5) * PX_TO_MM;
    const hMm = (canvas.height / 2.5) * PX_TO_MM;
    const pdf = new jsPDF({ unit: "mm", format: [wMm, hMm], orientation: wMm > hMm ? "landscape" : "portrait" });
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.95), "JPEG", 0, 0, wMm, hMm);
    pdf.save(filename);
}
